import { createContext } from 'react'
import type { User } from 'firebase/auth'
import type { AppRole } from '../../services/auth/roleService'

export type AuthContextValue = {
  user: User | null
  role: AppRole | null
  schoolId: string | null
  loading: boolean
  phase: 'signed_out' | 'authenticating' | 'firebase_resolved' | 'membership_resolving' | 'resolved'
  error: string | null
  signInWithEmail: (email: string, password: string) => Promise<void>
  logout: () => Promise<void>
  clearError: () => void
}

export const authContext = createContext<AuthContextValue | undefined>(undefined)
